import axios from 'axios';

import { downloadBlob } from '@qwealth/qcore';
import { REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';

import { AppThunkDispatch } from 'data/store';
import { errorHandler } from '../../services/axiosService';
import { TaxDocument, TaxDocumentDownloadList, TaxDocumentDownloadRequest } from '../models/taxDocuments';

export const fetchTaxDocumentsByYearAndQid = async (taxYear: number, qid: string, dispatch?: AppThunkDispatch): Promise<TaxDocument[]> => {
  try {
    const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/tax/${taxYear}/${qid}`);
    return response.data;
  } catch (e) {
    if (dispatch) {
      errorHandler(dispatch, 'API Error: Failed Fetching Tax Documents')(e);
    }
    return [];
  }
};

export const fetchTaxDocumentFile = async (taxDocument: TaxDocument, dispatch?: AppThunkDispatch): Promise<void> => {
  try {
    if (!taxDocument.s3Filename) {
      throw new Error('Value Error: Missing file location for tax document.');
    }

    const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/tax/doc/${taxDocument.s3Filename}/${taxDocument.documentName}`, {
      responseType: 'blob' as const,
    });

    const blobUrl = window.URL.createObjectURL(response.data);

    downloadBlob(blobUrl, `${taxDocument.documentName}.pdf`);
  } catch (e) {
    if (dispatch) {
      errorHandler(dispatch, `API Error: Failed to download tax document ${taxDocument.document}`)(e);
    }
  }
};

export const fetchAllTaxDocumentFiles = async (taxDocuments: TaxDocument[], dispatch?: AppThunkDispatch): Promise<void> => {
  try {
    const taxDocumentsWithFiles = taxDocuments.filter(doc => doc.status === 'received');
    if (taxDocumentsWithFiles.length == 0) {
      return;
    }

    const downloadRequestList: TaxDocumentDownloadRequest[] = taxDocumentsWithFiles.map(doc => {
      return {
        s3_url: doc.s3Filename,
        document_name: doc.documentName,
      } as TaxDocumentDownloadRequest;
    });

    const payload: TaxDocumentDownloadList = { tax_document_list: downloadRequestList };

    const response = await axios.post(`${REACT_APP_QWEALTH_API_V3}/tax`, payload, {
      responseType: 'blob' as const,
    });
    const blobUrl = window.URL.createObjectURL(response.data);
    downloadBlob(blobUrl, 'tax_files.zip');
  } catch (e) {
    if (dispatch) {
      errorHandler(dispatch, 'API Error: Failed to download tax documents.')(e);
    }
  }
};
